import {TOGGLE_MARKER, TOGGLE_TYPE, TOGGLE_LOADING, SET_TOGGLE_TYPES } from '../../actions/Map/mapActions.js';
import { cloneDeep } from 'lodash';
const _ = {cloneDeep};


export const initialState = {
  loading: false,
  toggleMarkers : {
  },
  toggleTypes : {
  }
};

export function mapReducer(state = initialState, action) {
  // let updatedState = {...state};
  let new_state = {...state};
  switch(action.type) {

    case TOGGLE_MARKER:
      let index = action.payload;
      let newToggleState = reverse(state.toggleMarkers, index);
      return {...state, toggleMarkers : newToggleState }

    //case TOGGLE_MARKER_ON: (In actions as well)

    case SET_TOGGLE_TYPES:
      let categories = action.payload;
      for (var i = 0; i < categories.length; i++) {
        new_state.toggleTypes[categories[i]] = {};
      }
      return new_state;

    case TOGGLE_TYPE:
      let category = action.payload.category;
      let type = action.payload.type;
      let value = action.payload.value;
      new_state.toggleTypes[category][type] = value;
      return new_state;

    case TOGGLE_LOADING:
      return { ...state, loading: !state.loading };
    default:
      return state;
  }
}

function reverse(obj, index) {
  let newObj = _.cloneDeep(obj);
  newObj[index] = !newObj[index];
  return newObj;
}



// WEBPACK FOOTER //
// ./src/reducers/Map/mapReducer.js